import { Component } from '@angular/core';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'egyptian-cure-bank-crm';
  isLoggedIn$ = this.authService.isLoggedIn$;

  constructor(private authService: AuthService) {}
}
